module.exports = __webpack_public_path__ + "a6cce958c4f108537aaec6ea8203c645.svg";